import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    researchQuestion: {
        width: "80%",
        marginTop: "30px",
        textAlign: "center",
        padding: "50px",
        color: "white",
        backgroundColor: "black",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    title: {
        fontFamily: "Garamond",
        paddingBottom: "50px",
    },
    information: {
        paddingBottom: "100px",
    },
    informationTwo: {
        paddingBottom: "100px",
    },
    listTitle: {
        width: "50%",
    },
    list: {
        width: "50%",
        textAlign: "left",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& li": {
            padding: "10px 0",
        },
    },
    informationThree: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "100px",
    },
    subList: {
        margin: "0px",
        padding: "0px",
    },
}));

export default useStyles;
